<template>
  <div class="d-flex flex-column">
    <div class="text-paragraph-2 font-weight-medium mt-1">
      {{planName}}
      <Tag
        class="text-caption gray--text text--scale500 font-weight-medium ml-sm-1 ml-md-2"
        small
        outlined
        :text="lc.additionalSite"
        v-if="isAdditional"
      />
    </div>
    <small
      v-text="includedDomainName"
      v-if="hasIncludedDomain"
    />
  </div>
</template>
<script>

import { Tag } from '@locaweb/design-system-vue'

export default {
  name: 'PlanInfo',
  components: {
    Tag
  },
  props: {
    isAdditional: {
      type: Boolean,
      required: true
    },
    plan: {
      type: Object,
      required: true
    }
  },
  computed: {
    lc () {
      return this.$lc('site.components.siteCard.planInfo')
    },
    planName () {
      const { name } = this.plan
      return this.lc.name.replaceValues({ name })
    },
    hasIncludedDomain () {
      return !!this.plan.includedDomain
    },
    includedDomainName () {
      const { includedDomain } = this.plan
      return this.lc.includedDomain.replaceValues({ includedDomain })
    }
  }
}
</script>
